import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '@codex/basics';

const HeaderTitle = styled.div`
  width: 100%;
  max-width: 119px;
  min-height: 118px;
  
  @media (max-width: 1239px) { 
    max-width: 140px;
    min-height: 100px;
  }
  
  @media (max-width: 1024px) { 
    max-width: 119px;
    min-height: 118px;
  }  
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 109px;
    min-height: 105px;
    margin-bottom: 2px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    margin-bottom: 10px;
    min-height: 102px;
  }
  
  a {
    font-family: Helvetica;
    font-size: 14px;
    color: #4855a0;
  }
`;

const HeaderTitleActual = styled.div`
  width: 100%;
  max-width: 119px;
  min-height: 118px;
  
  @media (max-width: 1239px) { 
    max-width: 140px;
    min-height: 100px;
  }
  
  @media (max-width: 1024px) { 
    max-width: 119px;
    min-height: 118px;
  }  
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 109px;
    min-height: 104px;
    margin-bottom: 2px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    margin-bottom: 10px;
    min-height: 102px;
  }
  
  a {
    font-family: Helvetica;
    font-size: 14px;
    color: #333333;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 128px; 
  text-align: center;
  margin-bottom: 15px;
  margin-right: 20px;
  
  a > img {
    width: 100%;
    max-width: 118px;
  }
  
  @media (max-width: 1239px) { 
    max-width: none;    
    margin-bottom: 15px;
    margin-right: 0px;
  }
  
  @media (max-width: 1024px) { 
    max-width: 128px;    
    margin-bottom: 30px;
    margin-right: 20px;
  }  
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    a > img {
      max-width: 87px;
    }
  
    max-width: 87px; 
    margin-bottom: 15px;
    margin-right: 10px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    a > img {
      max-width: 115px;
    }
    
    margin-bottom: 15px;
    margin-right: 0px;
  }
`;

const insertChar = (word, index, char) => word.substr(0, index) + char + word.substr(index);

const MAX_WORD_LENGTH = 13;
const MAX_TITLE_LENGTH = 45;

const shortenWord = (word) => {
  if (word.length > MAX_WORD_LENGTH) {
    return insertChar(word, 11, ' ');
  }
  return word;
};

const getSubTitle = (words, i) => words.slice(0, i).join(' ');

const shorten = (productTitle) => {
  const words = productTitle.split(' ');
  let end = false;
  let i = 0;
  while (!end && i <= words.length) {
    if (getSubTitle(words, i + 1).length > MAX_TITLE_LENGTH) {
      end = true;
    }
    i++;
  }
  return getSubTitle(words, i - 1);
};

export const getNormalizedTitle = (title) => shorten(title.split(' ').map(shortenWord).join(' '));

const ProductHeader = ({
  productTitle, productImgUrl, productUrl, isActualProduct, reviews
}) => {
  const ActualHeader = isActualProduct ? HeaderTitleActual : HeaderTitle;
  return (
    <>
      <ImageWrapper>
        <Link href={productUrl}>
          <img src={productImgUrl} alt={productTitle} />
        </Link>
      </ImageWrapper>
      <ActualHeader>
        <Link href={productUrl}>
          {getNormalizedTitle(productTitle)}
        </Link>
        {reviews}
      </ActualHeader>
    </>
  );
};

ProductHeader.propTypes = {
  productTitle: PropTypes.string.isRequired,
  productImgUrl: PropTypes.string.isRequired,
  productUrl: PropTypes.string.isRequired,
  isActualProduct: PropTypes.bool.isRequired,
  reviews: PropTypes.node.isRequired
};

export default ProductHeader;
